import faviconHap from 'presentation/assets/images/favicon.ico';
import faviconCcg from 'presentation/assets/images/favicon-ccg.ico';
import faviconGndi from 'presentation/assets/images/favicon-gndi.ico';
import faviconNotredame from 'presentation/assets/images/favicon-notredame.ico';
import type {ThemeNameType} from 'presentation/store/useThemeStore';
import {ProductEnum} from './productEnum';

type ProductBranding = {
	themeName: ThemeNameType;
	favicon: string;
};

export const PRODUCT_BRANDING: Record<ProductEnum, ProductBranding> = {
	[ProductEnum.HAP]: {
		themeName: 'hap',
		favicon: faviconHap,
	},
	[ProductEnum.CCG]: {
		themeName: 'hap',
		favicon: faviconCcg,
	},
	[ProductEnum.CLINIPAM]: {
		themeName: 'hap',
		favicon: faviconGndi,
	},
	[ProductEnum.GNDI_MINAS]: {
		themeName: 'hap',
		favicon: faviconGndi,
	},
	[ProductEnum.GNDI]: {
		themeName: 'hap',
		favicon: faviconHap,
	},
	[ProductEnum.NOTREDAME_SAUDE]: {
		themeName: 'notredame',
		favicon: faviconNotredame,
	},
};

export const DEFAULT_THEME_BY_PRODUCT: Record<ProductEnum, ThemeNameType> = {
	[ProductEnum.HAP]: PRODUCT_BRANDING[ProductEnum.HAP].themeName,
	[ProductEnum.CCG]: PRODUCT_BRANDING[ProductEnum.CCG].themeName,
	[ProductEnum.CLINIPAM]: PRODUCT_BRANDING[ProductEnum.CLINIPAM].themeName,
	[ProductEnum.GNDI_MINAS]: PRODUCT_BRANDING[ProductEnum.GNDI_MINAS].themeName,
	[ProductEnum.GNDI]: PRODUCT_BRANDING[ProductEnum.GNDI].themeName,
	[ProductEnum.NOTREDAME_SAUDE]: PRODUCT_BRANDING[ProductEnum.NOTREDAME_SAUDE].themeName,
};

export const FAVICON_BY_PRODUCT: Record<ProductEnum, string> = {
	[ProductEnum.HAP]: PRODUCT_BRANDING[ProductEnum.HAP].favicon,
	[ProductEnum.CCG]: PRODUCT_BRANDING[ProductEnum.CCG].favicon,
	[ProductEnum.CLINIPAM]: PRODUCT_BRANDING[ProductEnum.CLINIPAM].favicon,
	[ProductEnum.GNDI_MINAS]: PRODUCT_BRANDING[ProductEnum.GNDI_MINAS].favicon,
	[ProductEnum.GNDI]: PRODUCT_BRANDING[ProductEnum.GNDI].favicon,
	[ProductEnum.NOTREDAME_SAUDE]: PRODUCT_BRANDING[ProductEnum.NOTREDAME_SAUDE].favicon,
};
